import React, { Fragment, useState } from "react";
import Container from "react-bootstrap/Container";
import PropTypes from "prop-types";
import styled from "styled-components";
import dayjs from "dayjs";
import Fade from "react-bootstrap/Fade";

import ProfileDropdownComponent from "./Navbar/ProfileDropdown";
// import NotificationComponent from "./Navbar/Notification";
import ButtonComponent from "../../Components/Button";
import BriefcaseIcon from "../../Icons/Briefcase";
import LinkComponent from "../Link";
import useWidthHook from "../../Hooks/useWidth";
import UserStarIcon from "../../Icons/UserStar";
import TrainingIcon from "../../Icons/Training";
import CloseIcon from "../../Icons/Close";
import MenuIcon from "../../Icons/Menu";
import HomeIcon from "../../Icons/Home";
import LogoIcon from "../../Icons/Logo";

const propTypes = {
  user: PropTypes.object,
  profile: PropTypes.object,
  children: PropTypes.any,
  route: PropTypes.func,
  footer: PropTypes.bool
};

const defaultProps = {
  route: (path) =>
    (window.location.href = `https://${process.env.REACT_APP_PARENT_URL}${path}`),
  footer: false
};

const protocol = (() => {
  if (typeof window !== "undefined") {
    if (window.location.protocol === "https:") {
      return "https://";
    } else {
      return "http://";
    }
  }
})();

const Main = ({ user, route, profile, footer, children }) => {
  /**
   * hook
   */
  const width = useWidthHook();

  /**
   * state
   */
  const [toggle, setToggle] = useState(false);

  /**
   * variables
   */

  const navItems = [
    { icon: BriefcaseIcon, name: "Jobs", link: `/jobs` },
    { icon: UserStarIcon, name: "Mentorship", link: `/mentorship` },
    { icon: TrainingIcon, name: "Training", link: `/training` }
  ];

  const footerItems = [
    { name: "Find a job", link: "" },
    { name: "Post a job", link: "" },
    { name: "Join as a mentor", link: "" },
    { name: "Join as a trainer", link: "" },
    { name: "About us", link: "" },
    { name: "Careers", link: "" },
    { name: "FAQs", link: "/faqs" }
  ];

  return (
    <Fragment>
      <TopNav aria-label="Top nav" $toggle={toggle}>
        <Container className="d-flex justify-content-between h-100 align-items-center px-6 px-lg-4">
          <a
            aria-label="Logo"
            className="d-block"
            href={`${protocol}${process.env.REACT_APP_PARENT_URL}`}
          >
            <LogoIcon />
          </a>

          {width >= 1200 && (
            <ul className="d-flex align-items-center gap-14">
              {navItems.map((item, index) => (
                <li key={index}>
                  <Link
                    path={item.link}
                    exact={item.exact}
                    className="nav-link px-0"
                    {...{ route }}
                  >
                    {(active) => (
                      <Fragment>
                        <item.icon
                          color={active ? "var(--bs-primary)" : "#000"}
                          variant={active ? "default" : "outline"}
                        />
                        <small>{item.name}</small>
                      </Fragment>
                    )}
                  </Link>
                </li>
              ))}
            </ul>
          )}

          {user ? (
            <div className="d-flex align-items-center gap-8">
              {/* <NotificationComponent /> */}
              <ProfileDropdownComponent {...profile} />
            </div>
          ) : (
            <Fragment>
              {width >= 1200 ? (
                <div className="d-flex justify-content-end gap-4">
                  <ButtonComponent
                    className="px-4"
                    variant="secondary"
                    onClick={() => {
                      return (window.location.href = `${protocol}${process.env.REACT_APP_APP_URL}/auth/login`);
                    }}
                  >
                    Log in
                  </ButtonComponent>
                  <ButtonComponent
                    className="px-4"
                    onClick={() => {
                      return (window.location.href = `${protocol}${process.env.REACT_APP_APP_URL}/auth/signup`);
                    }}
                  >
                    Sign up
                  </ButtonComponent>
                </div>
              ) : (
                <LinkComponent onClick={() => setToggle(!toggle)}>
                  {toggle ? <CloseIcon /> : <MenuIcon />}
                </LinkComponent>
              )}
            </Fragment>
          )}
        </Container>
      </TopNav>

      {/* content of layout */}
      <Wrapper>{children}</Wrapper>
      {/* end of content of layout */}

      {/* footer */}
      {footer && (
        <Footer>
          <a
            className="mb-10 d-inline-block"
            href={`${protocol}${process.env.REACT_APP_PARENT_URL}`}
          >
            <LogoIcon color="var(--bs-gray)" />
          </a>
          <div className="pb-lg-6 pb-10 border-bottom border-gray-20 d-flex align-items-start justify-content-between mb-6">
            <div className="d-grid d-lg-flex gap-8 gap-lg-4">
              {footerItems.map((item, key) => (
                <a href={item.link} key={key} className="text-black">
                  {item.name}
                </a>
              ))}
            </div>

            <div className="d-grid d-lg-flex gap-8 gap-lg-4">
              {[
                {
                  name: "Terms of service",
                  link: process.env.REACT_APP_TERMS_AND_CONDITIONS
                },
                {
                  name: "Privacy policy",
                  link: process.env.REACT_APP_PRIVACY_POLICY
                }
              ].map((item, key) => (
                <a key={key} href={item.link} className="text-black">
                  {item.name}
                </a>
              ))}
            </div>
          </div>

          <div className="d-flex justify-content-between">
            <div className="d-flex gap-2 align-items-center">
              <span>&copy;</span>
              <small>Copyright</small>
              <small>{dayjs().format("YYYY")}</small>
            </div>
          </div>
        </Footer>
      )}
      {/* end of footer */}

      {/* bottom nav */}
      {width < 1200 && user && (
        <BottomNav aria-label="Botton nav">
          <ul>
            {navItems.map((item, index) => (
              <li key={index}>
                <Link
                  path={item.link}
                  exact={item.exact}
                  className="nav-link"
                  {...{ route }}
                >
                  {(active) => (
                    <Fragment>
                      <item.icon
                        className="mx-auto mb-1"
                        variant={active ? "default" : "outline"}
                        color={active ? "var(--bs-primary)" : "#000"}
                      />
                      <small>{item.name}</small>
                    </Fragment>
                  )}
                </Link>
              </li>
            ))}
          </ul>
        </BottomNav>
      )}

      {/* sidenav */}
      <SideNav aria-label="Side nav" $toggle={toggle}>
        <div className="d-flex align-items-center justify-content-between p-6">
          <LogoIcon />
          <ButtonComponent
            height={24}
            variant="custom"
            className="px-0"
            aria-label="Close"
            onClick={() => setToggle(false)}
          >
            <CloseIcon />
          </ButtonComponent>
        </div>
        <ul className="d-grid gap-10 py-10 px-6">
          {navItems.map((item, index) => (
            <li key={index}>
              <Link
                path={item.link}
                exact={item.exact}
                className="nav-link"
                {...{ route }}
              >
                {(active) => (
                  <Fragment>
                    <item.icon
                      variant={active ? "default" : "outline"}
                      color={active ? "var(--bs-primary)" : "#000"}
                    />
                    <small>{item.name}</small>
                  </Fragment>
                )}
              </Link>
            </li>
          ))}
        </ul>

        <div className="d-grid gap-4 mt-auto py-10 px-6">
          <ButtonComponent
            className="w-100"
            onClick={() => {
              return (window.location.href = `${protocol}${process.env.REACT_APP_APP_URL}/auth/signup`);
            }}
          >
            Sign up
          </ButtonComponent>
          <ButtonComponent
            className="w-100"
            variant="secondary"
            onClick={() => {
              return (window.location.href = `${protocol}${process.env.REACT_APP_APP_URL}/auth/login`);
            }}
          >
            Log in
          </ButtonComponent>
        </div>
      </SideNav>

      {/* sidenav backdrop */}
      <Fade
        in={toggle}
        mountOnEnter
        unmountOnExit
        onClick={() => setToggle(!toggle)}
      >
        <div className="modal-backdrop" style={{ zIndex: 900 }} />
      </Fade>
    </Fragment>
  );
};

/**
 * components
 */
const Link = ({ path, exact, children, className, route, ...props }) => {
  /**
   * variables
   */
  const active = ((path) => {
    const currentPath = window.location.pathname;

    if (exact) {
      if (currentPath === path) {
        return true;
      }
    } else {
      if (currentPath.includes(path)) {
        return true;
      }
    }

    return false;
  })(path);

  return (
    <a
      href={path}
      onClick={(e) => {
        e.preventDefault();

        if (e.metaKey || e.ctrlKey) {
          window.open(`${protocol}${process.env.REACT_APP_PARENT_URL}${path}`);
        } else {
          route(path);
        }
      }}
      className={`${className} ${active ? "active" : ""}`}
    >
      {children(active)}
    </a>
  );
};

/**
 * styles
 */
const SideNav = styled.nav`
  bottom: 0;
  width: 100%;
  height: 100%;
  z-index: 905;
  display: flex;
  position: fixed;
  flex-direction: column;
  background-color: #fff;
  transition: ease-in-out left 0.15s;
  left: ${({ $toggle }) => ($toggle ? "0" : "-100vw")};

  ul {
    margin: 0;
    padding: 0;
    list-style: none;
  }

  .nav-link {
    gap: 0.5rem;
    display: flex;
    padding: 0.5rem 0;
    align-items: center;
    color: #000 !important;

    &.active {
      color: var(--bs-primary) !important;
    }
  }

  @media (min-width: 768px) {
    width: 18.75rem;
    left: ${({ $toggle }) => ($toggle ? "0" : "-18.75rem")};
  }
`;

const BottomNav = styled.nav`
  bottom: 0;
  z-index: 10;
  height: 4.5rem;
  position: sticky;
  background-color: #fff;
  border-top: 1px solid var(--bs-gray-20);

  ul {
    margin: 0;
    padding: 0;
    display: grid;
    list-style: none;
    align-items: center;
    justify-content: space-between;
    grid-template-columns: repeat(3, 1fr);
  }

  .nav-link {
    text-align: center;
    padding: 0.75rem 1rem;
    color: #000 !important;

    * {
      display: block;
    }

    &.active {
      color: var(--bs-primary) !important;
    }
  }
`;

const Footer = styled.footer`
  padding: 4rem 1.5rem;
  background-color: var(--bs-gray-10);

  @media (min-width: 768px) {
    padding: 3.5rem 3rem;
  }

  @media (min-width: 992px) {
    padding: 5rem 4.5rem;
  }
`;

const Wrapper = styled.main`
  min-height: calc(100vh - 9rem);
`;

const TopNav = styled.nav`
  top: 0;
  z-index: 10;
  height: 3.5rem;
  position: sticky;
  background-color: #fff;
  opacity: ${({ $toggle }) => ($toggle ? "0" : "1")};

  ul {
    margin: 0;
    padding: 0;
    list-style: none;
  }

  .nav-link {
    gap: 0.5rem;
    display: flex;
    align-items: center;
    color: #000 !important;
    border-bottom: 3px solid transparent;

    &.active {
      color: var(--bs-primary) !important;
      border-color: var(--bs-primary);
    }
  }

  button {
    height: 2.25rem;
  }

  @media (min-width: 768px) {
    height: 4.5rem;

    button {
      height: 3rem;
    }
  }

  @media (min-width: 1200px) {
    height: 5rem;
  }
`;

Main.propTypes = propTypes;
Main.defaultProps = defaultProps;

export default Main;
